import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Wheat, Leaf, HeartPulse, Apple, Salad } from 'lucide-react';

export const DietaryFilters = ({ selectedDietary, onDietaryChange }) => {
  const dietaryOptions = [
    { value: 'all', label: 'All Dishes', icon: null },
    { value: 'millets', label: 'Millets', icon: Wheat },
    { value: 'vegan', label: 'Vegan', icon: Leaf },
    { value: 'gluten-free', label: 'Gluten-Free', icon: Salad },
    { value: 'low-carb', label: 'Low Carb', icon: HeartPulse },
    { value: 'diabetic-friendly', label: 'Diabetic Friendly', icon: Apple },
  ];

  return (
    <div className="flex flex-wrap gap-3 justify-center" data-testid="dietary-filters">
      {dietaryOptions.map((option) => {
        const Icon = option.icon;
        const isActive = selectedDietary === option.value;
        return (
          <button
            key={option.value}
            onClick={() => onDietaryChange(option.value)}
            data-testid={`dietary-filter-${option.value}`}
            className={`px-6 py-3 rounded-full font-['Outfit'] font-medium text-sm transition-all duration-300 flex items-center gap-2 ${
              isActive
                ? 'bg-[#F97316] text-white shadow-lg scale-105'
                : 'bg-white/70 backdrop-blur-md text-[#1C1917] hover:bg-white hover:shadow-md border border-[#1C1917]/10'
            }`}
          >
            {Icon && <Icon className="w-4 h-4" />}
            {option.label}
          </button>
        );
      })}
    </div>
  );
};